import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import strings from 'utils/strings'
import { TITLE_MAP } from '../utils/constants/dynamic-title-constants'

export const useDynamicTitle = (options = {}) => {
  const location = useLocation()

  useEffect(() => {
    const { overrideTitle } = options
    const searchParams = new URLSearchParams(location.search)
    const queryTerm = searchParams.get('q')
    const isEditing = searchParams.get('editing') === 'true'

    const pathnames = location.pathname.split('/').filter((x) => x)
    const filteredPathnames = pathnames.filter(
      (segment) => segment.toLowerCase() !== strings.chec.toLowerCase()
    )

    let finalTitle = ''

    if (queryTerm) {
      const currentSegment = filteredPathnames[filteredPathnames.length - 1]
      const sectionName = TITLE_MAP[currentSegment] || currentSegment
      finalTitle = `'${queryTerm}' - ${strings.search} ${sectionName}`
    } else if (filteredPathnames.length > 0) {
      if (filteredPathnames.length === 1) {
        const [firstSegment] = filteredPathnames
        const sectionName = TITLE_MAP[firstSegment] || firstSegment

        const isInfoSection = [
          'release-notes',
          'requirements',
          'line-note-reader',
          'dash-layout',
          'ctp',
          'odx-data-translator',
          'fast-feature-errors',
        ].includes(firstSegment.toLowerCase())

        const displayName = overrideTitle || sectionName

        finalTitle = isInfoSection
          ? displayName
          : `${strings.search} ${displayName}`
      } else {
        const isRefParam = filteredPathnames[0] === 'reference-parameters'
        const segmentsToProcess = isRefParam
          ? filteredPathnames.slice(0, 2)
          : filteredPathnames.slice(0, 3)

        const mappedTitles = segmentsToProcess.map(
          (segment) => TITLE_MAP[segment] || segment
        )

        const [primarySection, ...rest] = mappedTitles

        let finalSegments = [...rest]
        if (overrideTitle) {
          if (finalSegments.length > 0) finalSegments[0] = overrideTitle
          else finalSegments = [overrideTitle]
        }

        if (finalSegments.length === 1 || isRefParam)
          finalTitle = `${finalSegments[0]} - ${primarySection}`
        else finalTitle = [...finalSegments].reverse().join(' - ')
      }
    } else finalTitle = strings.chec_main_title

    if (isEditing) finalTitle = `${strings.editing || 'Editing'} ${finalTitle}`

    document.title = finalTitle || strings.chec_main_title
  }, [location, options, options.overrideTitle])
}

export const refreshFavicon = (iconPath) => {
  const link =
    document.querySelector("link[rel~='icon']") ||
    document.createElement('link')
  link.rel = 'icon'
  const versioning = `?v=${new Date().getTime()}`
  link.href = `${iconPath}${versioning}`

  if (!document.querySelector("link[rel~='icon']")) {
    document.getElementsByTagName('head')[0].appendChild(link)
  }
}
